import React, { PureComponent } from 'react'
import { Player } from 'video-react'
import '../../node_modules/video-react/dist/video-react.css' // import css

export default class ScreenSaver extends PureComponent {
    componentWillReceiveProps(nextProps) {
        if (nextProps.enabled != this.props.enabled) {
            if (nextProps.enabled) {
                this.refs.player.play()
            } else {
                this.refs.player.pause()
            }
        }
    }
    render() {
        return (
            <div style={{ display: this.props.enabled ? 'inherit' : 'none' }} className="screen-saver">
                <Player ref="player" autoPlay={true} muted={true} loop={true} controls={false} style={{ flex: 1 }} src="presentation_BauenimBestand.mp4" />
            </div>
        )
    }
}
